import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

export const ListItemPlaceholder = ({ withFlashing }) => (
  <div className={styles.singleListItem}>
    <div className={styles.listItem}>
      <div className={classNames(styles.listItemIcon, withFlashing && styles['base-flash'])} />
      <div className={classNames(styles.rectangle, withFlashing && styles['base-flash'])} />
    </div>
  </div>
);

ListItemPlaceholder.propTypes = {
  withFlashing: PropTypes.bool,
};

ListItemPlaceholder.defaultProps = {
  withFlashing: true,
};

export const SingleLinePlaceholder = ({ withFlashing }) => (
  <div className={classNames(styles.rectangleShort, withFlashing && styles['base-flash'])} />
);

SingleLinePlaceholder.propTypes = {
  withFlashing: PropTypes.bool,
};

SingleLinePlaceholder.defaultProps = {
  withFlashing: true,
};

export const TwoLinePlaceholder = ({ type, withFlashing }) => (
  <div className={styles.listItem}>
    <div className={classNames(styles[type], withFlashing && styles['base-flash'])} />
    <div>
      <div className={classNames(styles.rectangle, withFlashing && styles['base-flash'])} />
      <div className={classNames(styles.rectangleShort, withFlashing && styles['base-flash'])} />
    </div>
  </div>
);

TwoLinePlaceholder.propTypes = {
  /**
   * String to determine what kind of shape to render.
   */
  type: PropTypes.oneOf(['circle', 'rectangle', 'square']),
  withFlashing: PropTypes.bool,
};

TwoLinePlaceholder.defaultProps = {
  type: 'square',
  withFlashing: true,
};
